<div *ngIf="isLoading$ | async" class="tab-spinner-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div *ngIf="(isLoading$ | async) === false && (playersResult$ | async) as result">

  <ng-container *ngIf="result.data.length > 0; else noResultsTemplate">
    <mat-list role="list">
      <ng-container *ngFor="let player of result.data">
        <mat-list-item
          role="listitem"
          class="player-list-item"
          [routerLink]="['/statistics', 'player', player.player_id]">

          <mat-icon matListItemIcon>person</mat-icon>
          <div matListItemTitle class="player-name">{{ player.player_name }}</div>
          <div matListItemLine class="player-meta">
            <span>{{ player.team_name }}</span>
          </div>

        </mat-list-item>
        <mat-divider></mat-divider>
      </ng-container>
    </mat-list>

    <mat-paginator
      *ngIf="result.total_results > result.page_size"
      [length]="result.total_results"
      [pageSize]="result.page_size"
      [pageIndex]="result.page - 1"
      (page)="handlePageEvent($event)"
      [showFirstLastButtons]="true"
      aria-label="Seleccionar página">
    </mat-paginator>
  </ng-container>

  <ng-template #noResultsTemplate>
    <div class="no-results-container">
      <mat-icon>search_off</mat-icon>
      <p>No se encontraron jugadores para los filtros seleccionados.</p>
    </div>
  </ng-template>

</div>

<div *ngIf="(isLoading$ | async) === false && (playersResult$ | async) === null" class="no-results-container">
  <mat-icon>filter_list</mat-icon>
  <p>Selecciona una Temporada y Competición para iniciar la búsqueda.</p>
</div>
